import React from "react"
import { useIntl } from "react-intl"
import { useParams, Route } from "react-router-dom"
import { NeedsApproval } from "../../views/merchantdecline/NeedsApproval"
import { Box } from "@carrotfertility/carotene-core"
import { MerchantDenied } from "../../views/merchantdecline/MerchantDenied"
import { MerchantApproved } from "../../views/merchantdecline/MerchantApproved"
import { MerchantDeclineError } from "../../views/merchantdecline/MerchantDeclineError"
import { AppAccessPageLayout } from "#/components/access-page/AppAccessPageLayout"
import { AppAccessPageCard } from "#/components/access-page/AppAccessPageCard"
import { Switch } from "../../../services/routing/Switch"

const MerchantDeclineContainer = () => {
  // @ts-expect-error TS(2339) FIXME: Property 'token' does not exist on type '{}'.
  const { token } = useParams()
  const intl = useIntl()

  return (
    <AppAccessPageLayout title={intl.formatMessage({ defaultMessage: "Carrot Card declined" })}>
      <AppAccessPageCard showLocaleSelector={false}>
        <Box sx={(theme) => ({ margin: theme.tokens.spacing.lg })}>
          <Switch>
            <Route exact path="/confirm/error" component={MerchantDeclineError} />
            <Route exact path="/confirm/:token/deny" component={MerchantDenied} />
            <Route exact path="/confirm/:token/approve" component={MerchantApproved} />
            {/* @ts-expect-error TS(2322) FIXME: Type '{ token: any; }' is not assignable to type '... Remove this comment to see the full error message */}
            <Route exact path="/confirm/:token" render={() => <NeedsApproval token={token} />} />
          </Switch>
        </Box>
      </AppAccessPageCard>
    </AppAccessPageLayout>
  )
}

export default MerchantDeclineContainer
